<div class="search-component">
    <div class="table-container">
        <h4>
            Manage Policy Reports
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button (click)="toggleSidePanel()">
                        Manage <i class="fas fa-cog"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">
                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getActiveReports(paging)">
                    <button class="search-button" (click)="getActiveReports(paging)">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>
                </div>
            </div>
        </div>

        <pageable-table
            [items]="activeReports"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getActiveReports($event)"
            [showEdit]="false"
            [showDelete]="false">
        </pageable-table>
    </div>
</div>

<side-panel [isVisible]="showSidePanel" [caption]="panelCaption" (onDone)="onSidePanelDone()" (onCancel)="onSidePanelCancel()">
    <div class="sidebar">
        <div class="search-container">
            <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="getOptionalReports()">

            <button class="search-button" (click)="getOptionalReports()">
                <i class="fas fa-magnifying-glass"></i>
            </button>
        </div>
        <div class="report-list">
            <div *ngFor="let report of optionalReports" class="report-item">
                <switch-control
                    name="isSelected-{{ report.id }}"
                    [(ngModel)]="report['isSelected']"
                    [label]="report['reportName']">
                </switch-control>
            </div>
        </div>
    </div>
</side-panel>